import { createSlice } from '@reduxjs/toolkit';

const selectOptionsSlice = createSlice({
  name: "selectOptions",
  initialState: { options: [] },
  reducers: {
    selectOptions(state, action) {
      const { payload } = action;
      return { ...state, options: payload };
    },
    kycSelectOptions(state, action) {
      const { payload } = action;

      return { ...state, options: payload };
    },
  },
});

export const { selectOptions } = selectOptionsSlice.actions;
export default selectOptionsSlice.reducer;
